<script lang="ts">
  /**
   * The incoming-attack meter.
   *
   * `docs/DESIGN.md`, duel: "Incoming meter fed by server state, not local
   * guessing." The number it draws comes from `StateMessage.incoming`, which
   * the server computes from *its own* pending-garbage queue: not from the
   * local simulation, and not from watching what the opponent's board did.
   * That distinction is the whole point of the line in the spec, so this
   * component takes a plain number and refuses to compute one.
   *
   * A borderless track on the quiet fill, filled from the bottom in the
   * accent, and in the danger colour once four or more lines are waiting.
   */
  const { lines }: { lines: number } = $props();

  /** The meter is as tall as the well is in rows. */
  const rows = 20;

  const filled = $derived(Math.min(rows, Math.max(0, lines)));
  const urgent = $derived(filled >= 4);
</script>

<div class="meter" aria-label={`${String(lines)} lines incoming`}>
  <div class="track">
    <div class="fill" class:urgent style={`height: ${String((filled / rows) * 100)}%`}></div>
  </div>
  <span class="count" class:urgent>{lines > 0 ? lines : ''}</span>
</div>

<style>
  .meter {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--ui-space-1);
    height: 100%;
  }

  .track {
    position: relative;
    flex: 1 1 auto;
    width: 0.6rem;
    min-height: 4rem;
    border-radius: var(--ui-radius-pill);
    background: var(--ui-surface-2);
    overflow: hidden;
  }

  .fill {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--ui-accent);
    transition: height 120ms linear;
  }

  .fill.urgent {
    background: var(--ui-danger);
  }

  .count {
    font: var(--ui-text-eyebrow);
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    min-height: 1em;
    line-height: 1;
    color: var(--ui-ink-2);
  }

  .count.urgent {
    color: var(--ui-danger);
    font-weight: 800;
  }
</style>
